<script setup>
defineProps({
  /** orange, muted, ink, light (for dark tiles) */
  tone: { type: String, default: 'orange' },
  as: { type: String, default: 'p' },
});
</script>

<template>
  <component :is="as" class="pd-eyebrow" :class="`pd-eyebrow--${tone}`"><slot /></component>
</template>

<style scoped>
.pd-eyebrow {
  margin: 0;
  font-size: var(--pd-fs-eyebrow);
  font-weight: 800;
  letter-spacing: var(--pd-track-wide);
  text-transform: uppercase;
  line-height: 1.3;
}
.pd-eyebrow--orange { color: var(--pd-orange-text); }
.pd-eyebrow--muted { color: var(--pd-muted); }
.pd-eyebrow--ink { color: inherit; }  /* follows the surface: ink on light tiles, white on orange */
.pd-eyebrow--light { color: var(--pd-orange-hover); }
</style>
